// This function allow to reference chunks
__webpack_require__.k = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "" + {"c8a": "primer-react-css","xzc": "primer-react-brand-css",}[chunkId] + "." + {"c8a": "b1b172a8b1edfe83","xzc": "debd14c043072437",}[chunkId] + ".module.css"
}